export default __webpack_public_path__ + "static/media/1.d5d8f372.png";